/**
 * ```
 * @prettier
 * ```
 */

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    avatars: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    button: {
      type: Object,
      required: false,
      default: () => {
        return {
          link: "",
          text: "",
        };
      },
    },
  },
};
